import  './../css/GSideBar.css';
import  './../css/GPostJob.css';
import  './../css/GMediaQuery.css';
import  './../css/Gtop.css';
import  './../css/GAnimetion.css';
import  './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {systemConfiguration} from "../../../src/CommonImports";

function GSingleSider(){
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
return (
    <div className="col-lg-4 col-md-12 col-sm-12 col-12 ps-lg-4 mt-4 mt-lg-0">
        <div className="sidebar-shadow">
            <div className="sidebar-heading">
                <div className="avatar-sidebar d-flex align-items-center">
                    <figure>
                        <img alt="jobhub" src={mediaUrl + "avatar-job.png?" + sasToken} className="img-fluid rounded-circle" />
                    </figure>
                    <div className="sidebar-info ms-3">
                        <span className="sidebar-company">Grastech3</span>
                        <span className="sidebar-website-text">Grastech3 IT Solutions Pvt Ltd.</span>
                        <div className="dropdown">
                            <button className="btn btn-link dropdown-toggle p-0" type="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="dots">...</span>
                            </button>
                            <ul className="dropdown-menu dropdown-menu-light">
                                <li><a className="dropdown-item" href="#">Contact</a></li>
                                <li><a className="dropdown-item" href="#">Bookmark</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-description mt-3">
                We're looking to add more product designers to our growing teams.
            </div>
            <div className="text-start mt-3">
                <a href="#" className="btn btn-primary me-2">Apply now</a>
                <a href="#" className="btn btn-outline-secondary">Save job</a>
            </div>
            <div className="sidebar-list-job mt-4">
                <ul className="list-unstyled">
                    <li className="d-flex align-items-center mb-3">
                        <div className="sidebar-icon-item me-3"><i className="fi-rr-briefcase"></i></div>
                        <div className="sidebar-text-info">
                            <span className="text-description">Job Type</span>
                            <strong className="small-heading">Full-time / Remote</strong>
                        </div>
                    </li>
                    <li className="d-flex align-items-center mb-3">
                        <div className="sidebar-icon-item me-3"><i className="fi-rr-marker"></i></div>
                        <div className="sidebar-text-info">
                            <span className="text-description">Location</span>
                            <strong className="small-heading">Grastech3 IT Solutions Pvt Ltd.1st floor, Hare Krishna Heights,Vidya valley road, Sus Gaon Pune -411021<br />Remote Friendly</strong>
                        </div>
                    </li>
                    <li className="d-flex align-items-center mb-3">
                        <div className="sidebar-icon-item me-3"><i className="fi-rr-dollar"></i></div>
                        <div className="sidebar-text-info">
                            <span className="text-description">Salary</span>
                            <strong className="small-heading">$35k - $45k</strong>
                        </div>
                    </li>
                    <li className="d-flex align-items-center mb-3">
                        <div className="sidebar-icon-item me-3"><i className="fi-rr-clock"></i></div>
                        <div className="sidebar-text-info">
                            <span className="text-description">Date posted</span>
                            <strong className="small-heading">1 hour ago</strong>
                        </div>
                    </li>
                    <li className="d-flex align-items-center">
                        <div className="sidebar-icon-item me-3"><i className="fi-rr-time-fast"></i></div>
                        <div className="sidebar-text-info">
                            <span className="text-description">Expiration date</span>
                            <strong className="small-heading">April 06, 2022</strong>
                        </div>
                    </li>
                </ul>
            </div>
            <div className="sidebar-team-member pt-4">
                <h6 className="small-heading">Team member</h6>
                <div className="sidebar-list-member">
                    <ul className="list-unstyled d-flex flex-wrap">
                        {["avatar1.png", "avatar2.png", "avatar3.png", "avatar4.png", "avatar5.png", "avatar6.png", "avatar7.png", "avatar8.png"].map((avatar, index) => (
                            <li key={index}>
                                <a href="#">
                                    <figure>
                                        <img alt="jobhub" src={mediaUrl + avatar + "?" + sasToken} className="img-fluid rounded-circle" />
                                    </figure>
                                </a>
                            </li>
                        ))}
                    </ul>

                </div>
            </div>
            <div className="sidebar-team-member pt-4">
                <h6 className="small-heading">Contact Info</h6>
                <div className="info-address">
                    <span><i className="fi-rr-marker"></i> <span>Grastech3 IT Solutions Pvt Ltd.1st floor, Hare Krishna Heights,Vidya valley road, Sus Gaon Pune -411021</span></span>
                    <span><i className="fi-rr-headset"></i> <span>(+91) -8452041545</span></span>
                    <span><i className="fi-rr-paper-plane"></i> <span><a href="mailto:info@grastech3solutions.com">info@grastech3solutions.com</a></span></span>
                    <span><i className="fi-rr-time-fast"></i> <span>10:00 - 18:00, Mon - Sat </span></span>
                </div>
            </div>
        </div>

        <div className="sidebar-normal mt-4">
            <h6 className="small-heading">Are you also hiring?</h6>
            <ul className="ul-lists">
                <li><a href="#">Writing & Translation</a></li>
                <li><a href="#">Video & Animation</a></li>
                <li><a href="#">Music & Audio</a></li>
                <li><a href="#">Digital Marketing</a></li>
                <li><a href="#">Business</a></li>
                <li><a href="#">Programming & Tech</a></li>
            </ul>
        </div>
    </div>

)

}
export default GSingleSider;